<template>
  <tr class="default-table-row" :style="custom_style" v-bind="$attrs">
    <slot></slot>
  </tr>
</template>

<script lang="ts">
export default {
  props: {
    custom_style: {
      default: '',
      required: false,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.default-table-row:nth-child(even) {
  background-color: #f9f9f9;
}

.default-table-row:nth-child(odd) {
  background-color: white;
}

.default-table-row tr {
  font-weight: bold;
}
</style>
